var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
/* eslint-disable no-underscore-dangle */
import { useReducer, useMemo, useCallback } from 'react';
import { immerable, produce } from 'immer';
/**
 * コンポーネントで利用するステートクラス
 */
var State = /** @class */ (function () {
    function State() {
        this[_a] = true;
    }
    State.prototype._reduce = function (payload) {
        var _this = this;
        return produce(this, function (draft) { return _this.reduce.call(draft, payload); });
    };
    return State;
}());
export { State };
_a = immerable;
/**
 * UseCaseでdispatchするイベントのPayloadクラス
 */
var Payload = /** @class */ (function () {
    function Payload() {
    }
    return Payload;
}());
export { Payload };
/**
 * UseCaseが実行される直前に飛ぶPayload
 */
var WillExecutedPayload = /** @class */ (function (_super) {
    __extends(WillExecutedPayload, _super);
    function WillExecutedPayload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WillExecutedPayload';
        return _this;
    }
    return WillExecutedPayload;
}(Payload));
export { WillExecutedPayload };
/**
 * UseCaseが実行された直後に飛ぶPayload
 */
var DidExecutedPayload = /** @class */ (function (_super) {
    __extends(DidExecutedPayload, _super);
    function DidExecutedPayload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'DidExecutedPayload';
        return _this;
    }
    return DidExecutedPayload;
}(Payload));
export { DidExecutedPayload };
/**
 * UseCaseでエラーが発生したときにdispatchされるPayload
 */
var ErrorPayload = /** @class */ (function (_super) {
    __extends(ErrorPayload, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function ErrorPayload(error) {
        var _this = _super.call(this) || this;
        _this.error = error;
        _this.type = 'ErrorPayload';
        return _this;
    }
    return ErrorPayload;
}(Payload));
export { ErrorPayload };
var UseCaseExecutor = /** @class */ (function () {
    function UseCaseExecutor(useCase) {
        this.useCase = useCase;
    }
    UseCaseExecutor.prototype.execute = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var _b;
            _this.useCase.dispatch(new WillExecutedPayload());
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var result = (_b = _this.useCase).execute.apply(_b, args);
            return Promise.resolve(result).then(function () {
                resolve();
                _this.useCase.dispatch(new DidExecutedPayload());
            }, function (error) {
                _this.useCase.dispatch(new ErrorPayload(error));
                return reject(error);
            });
        });
    };
    return UseCaseExecutor;
}());
export { UseCaseExecutor };
var UseCase = /** @class */ (function () {
    function UseCase() {
        this.dispachers = [];
    }
    UseCase.prototype.dispatch = function (payload) {
        this.dispachers.forEach(function (dispatcher) { return dispatcher.dispatch(payload); });
    };
    UseCase.prototype.addDispatcher = function (dispatcher) {
        this.dispachers.push(dispatcher);
    };
    UseCase.prototype.usecase = function (useCase) {
        this.dispachers.forEach(function (dispacher) {
            useCase.addDispatcher(dispacher);
        });
        return new UseCaseExecutor(useCase);
    };
    return UseCase;
}());
export { UseCase };
/**
 * コンポーネントでユースケースを利用するhooks
 *
 * @param initialState 初期ステート
 */
export function useUseCase(initialState) {
    var _b = useReducer(function (s, p) { return s._reduce(p); }, initialState), _state = _b[0], _dispatch = _b[1];
    var _useCase = useCallback(function (useCase) {
        useCase.addDispatcher({ dispatch: _dispatch });
        return new UseCaseExecutor(useCase);
    }, []);
    return useMemo(function () { return ({
        state: _state,
        // useCaseにするとhooksの名前と判定されてしまい、eslintでエラーになるので、usecaseとする
        usecase: _useCase,
    }); }, [_state, _useCase]);
}
